import { getStorageKey } from "../../utils/localStorageStateUniqueKeyGenerator.js";

export const handlePhoneInputChange = (
  value,
  currentContextType,
  acctPhoneNumberErrors,
  setAcctPhoneNumberValue,
  setAcctPhoneNumberErrors
) => {
  setAcctPhoneNumberValue(value); // Update state
  const Key = getStorageKey("verifyAccountValue", currentContextType);
  console.log("Generated localStorage Key:", Key); // Debugging the generated key
  console.log("Phone Input Value:", value); // Debugging the input value
  localStorage.setItem(Key, value);
  if (acctPhoneNumberErrors) {
    setAcctPhoneNumberErrors("");
  }
};
